import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/components/HomePage.vue';
import Account from '@/Special/Account.vue';
import ProductsPage from '@/components/Market/Products.vue';
import ProductSellers from '@/components/Market/ProductSellers.vue';
import Services from '@/components/Market/Services.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/products',
    name: 'ProductsPage',
    component: ProductsPage
  },
  {
    path: '/services',
    name: 'ServicesPage',
    component: Services
  },
  {
    path: '/products/:id/sellers',
    name: 'ProductSellers',
    component: ProductSellers
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to) => {
  const loggedUser = localStorage.getItem('auth_token');

  if (to.meta.requiresAuth && !loggedUser) {
    return { name: 'Home' };
  }

  return true;
});

export default router;